module.exports = __webpack_public_path__ + "img/brand-block-3.4a2f2fc0.png";